import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { GREEN, RED } from '../../_config/consts';

export default function OnlineStatusBadge({ online, style }) {
  return (
    <span
      style={{
        display: 'inline-block',
        fontSize: 13,
        fontWeight: 'bold',
        color: online ? GREEN : RED,
        padding: '4px 10px',
        borderRadius: 12,
        backgroundColor: online ? 'rgba(76, 175, 80, 0.12)' : 'rgba(244, 67, 54, 0.12)',
        flexShrink: 0,
        ...style,
      }}
    >
      <Entity entity={online ? 'deviceOnline' : 'deviceOffline'} />
    </span>
  );
}
